import $ from 'jquery'

$(function () {
  // 市区町村入力
  // 都道府県
  // ES module 化(strict mode)に伴い宣言を明示（旧 webpack では暗黙のグローバルとして動いていた）
  const $prefSelects = $('select[name="prefecture"]')

  const prefLoadStart = ($prefSelect) => {
    $prefSelect.attr('disabled', 'disabled').find('option:eq(0)').html('読み込み中')
  }
  const prefLoadEnd = ($prefSelect) => {
    $prefSelect.attr('disabled', false).find('option:eq(0)').html('都道府県を選択')
  }
  const cityLoadStart = ($citySelect) => {
    $citySelect.attr('disabled', 'disabled').find('option:eq(0)').html('読み込み中')
  }
  const cityLoadEnd = ($citySelect) => {
    $citySelect.attr('disabled', false).find('option:eq(0)').html('市区町村を選択')
  }

  const getCities = ($citySelect, kenId, cityId = null) => {
    $.getJSON('/api/internal/v1/cities/' + kenId).done(function (json) {
      const cities = json.result;
      cities.forEach(function (city) {
        const $option = $("<option>").val(city.city_id).html(city.city_name);
        if (cityId != null) {
          $option.attr('selected', cityId == city.city_id)
        }
        $citySelect.append($option)
      })
      cityLoadEnd($citySelect)
    })
  }

  // 初期表示
  $prefSelects.each(function () {
    const $prefSelect = $(this)
    const $form = $prefSelect.closest('form')
    if (!$form.length) {
      return
    }

    const $citySelect = $form.find('select[name="city"]')
    const selectedKenId = $form.find('input[name="selected_ken_id"]')
    const selectedCityId = $form.find('input[name="selected_city_id"]')

    prefLoadStart($prefSelect)
    $citySelect.attr('disabled', 'disabled')

    // 市区町村
    $prefSelect.on('change', function () {
      $citySelect
          .empty()
          .append('<option value="">市区町村を選択</option>');
      cityLoadStart($citySelect)

      const kenId = $(this).val();
      if (kenId === '') {
        return
      }

      getCities($citySelect, kenId)
    })

    // 画面描画時に既に市区町村がセットされている場合の市区町村取得
    if (
      selectedKenId.length &&
      selectedKenId.val() &&
      selectedCityId.length &&
      selectedCityId.val()
    ) {
      getCities($citySelect, selectedKenId.val(), selectedCityId.val())
    }
  })

  $.getJSON('/api/internal/v1/prefectures').done(function (json) {
    const prefs = json.result;
    $prefSelects.each(function () {
      const $prefSelect = $(this)
      const $form = $prefSelect.closest('form')
      if (!$form.length) {
        return
      }

      const $citySelect = $form.find('select[name="city"]')
      const selectedKenId = $form.find('input[name="selected_ken_id"]')
      const selectedCityId = $form.find('input[name="selected_city_id"]')

      prefs.forEach(function(pref) {
        const $option = $("<option>").val(pref.ken_id).html(pref.ken_name)
        if (selectedKenId.length) {
          $option.attr('selected', selectedKenId.val() == pref.ken_id)
        }
        $prefSelect.append($option)
      });
      if (
        selectedKenId.length &&
        selectedKenId.val() &&
        selectedCityId.length === 0
      ) {
        cityLoadStart($citySelect)
        getCities($citySelect, selectedKenId.val())
      }
      prefLoadEnd($prefSelect)
    })
  })
})
